import React, { useState, useEffect } from 'react';
import '../static/fullpage.parallax.min';
import ReactFullpage from '@fullpage/react-fullpage';

import Button from '@material-ui/core/Button';
import Grid from '@material-ui/core/Grid';

import intro from "../static/img/intro.jpg";

import youtube_capture from "../static/img/youtube_capture.png";
import metabolism from "../static/img/metabolism.jpg";
import food2 from "../static/img/food2.jpg";

import web1 from "../static/img/web1.png";
import web2 from "../static/img/web2.png";
import web3 from "../static/img/web3.png";

import mobile1 from "../static/img/playstore.png";
import mobile2 from "../static/img/appstore.png";

import '../scss/Home.scss';

const Home = () => {
  const [mobile, setMobile] = useState(false);
  let fullpage = null;

  useEffect(() => {
    onResize();
    window.addEventListener('resize', onResize, { passive: true });
  }, []);

  const onResize = () => {
    let ismobile = (window.innerWidth < 600) || (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent));
    setMobile(ismobile);
    console.log(ismobile);
  }

  const onClickAppStore = () => {
    alert('앱스토어는 준비중입니다.')
  }

  return (
    <div className="Home">

      <div id="header">
        <ul className="list" style={{ margin:1, padding:13}}>
          <li style={{ margin:0, padding:0, paddingLeft:0, paddingRight:0, width: (mobile)?'80px':'100px'}}>
            <Button className="button" onClick={() => fullpage.moveTo(1)} style={{
              fontWeight:'bold',
              letterSpacing:'-1px',
              fontSize:(mobile)?"0.9em":"1.1em"}}>
              겨울잠
            </Button>
          </li>
          <li style={{ margin:0, padding:0, paddingLeft:5, paddingRight:5, width: (mobile)?'80px':'100px'}}>
            <Button className="button"  onClick={() => fullpage.moveTo(2)} style={{
              fontWeight:'bold',
              letterSpacing:'-1px',
              fontSize:(mobile)?"0.9em":"1.1em"}}>
              동면중
            </Button>
          </li>
          <li style={{ margin:0, padding:0, paddingLeft:5, paddingRight:5, width: (mobile)?'80px':'100px'}}>
            <Button className="button"  onClick={() => fullpage.moveTo(3)} style={{
              fontWeight:'bold',
              letterSpacing:'-1px',
              fontSize:(mobile)?"0.9em":"1.1em"}}>
              YOUTUBE
            </Button>
          </li>
          <li style={{ margin:0, padding:0, paddingLeft:10, paddingRight:10, width: (mobile)?'80px':'100px'}}>
            <Button className="button" onClick={() => fullpage.moveTo(4)} style={{
              fontWeight:'bold',
              letterSpacing:'-1px',
              fontSize:(mobile)?"0.9em":"1.1em"}}>
              운동도우미
            </Button>
          </li>
        </ul>
      </div>

      <ReactFullpage
        //fullpage options
        parallax
        licenseKey = {'CF33119B-4ED34006-96E07F8B-B2D3F8EB'}
        parallaxKey = {'d2ludGVyLXNsZWVwaW5nLmNvbV9sYjZjR0Z5WVd4c1lYZz0zaHA='}
        scrollingSpeed = {1000} /* Options here */

        render={({ state, fullpageApi }) => {
          fullpage = fullpageApi;
          return (
            <ReactFullpage.Wrapper>
              <div  className="section" id="_1" style={{ flexGrow: 1, }}>
                <Grid container >
                  <Grid item xs={12} style={{padding:10}}>
                    <div style={{
                      fontWeight: 900,
                      fontSize: (mobile) ? "3em":"5em",
                      color: 'white',
                      lineHeight: 1,
                    }}>
                      WE SUPPORT YOUR ENTHUSIASM
                    </div>
                    <div style={{
                      fontWeight: 900,
                      fontSize: (mobile) ? "1em":"2em",
                      color: 'white',
                    }}>
                      겨울잠이 건강한 삶을 향해 나아가도록 도와드립니다.
                    </div>
                  </Grid>

                </Grid>
              </div>
              <div className="section" id="_2" style={{ flexGrow: 1, alignItems: 'center' }}>
                <Grid container xs={12} style={{backgroundColor:'white'}}>
                  <Grid item xs={12} sm={6} style={{padding:10,}} align="center">
                    {/* <div style={{
                      width: '100%',
                      height: '100%',
                      backgroundImage: `url(${intro})`,
                      backgroundRepeat: 'no-repeat',
                      backgroundSize: '100%',
                      backgroundPosition: "center center",
                    }}>

                    </div> */}
                    <img src={intro} style={{ width: "100%", }}/>
                    {/* <div style={{
                      width: '400px',
                      height: '400px',
                      backgroundImage: 'url("https://s3.ap-northeast-2.amazonaws.com/images.wintersleeping/main_pic.png")',
                      backgroundSize: '400px',
                      backgroundPosition: "center center",
                    }}>
                        &nbsp;
                    </div> */}
                  </Grid>
                  <Grid item xs={12} sm={6} style={{padding:10}} align="left">
                    <p align="left" style={{
                      // width: (mobile) ? "80%":"100%",
                      color: "black",
                      fontSize: (mobile) ? "1em":"1.2em",
                      fontWeight: 'bold',
                    }}>
                      <div className='line-before' style={{ position:'relative', borderBottom:"1px solid #dddddd", marginBottom:20, fontSize:'1.2em', padding:10,  }}>
                        동면중
                      </div>
                      <div style={{color:'#555555'}}>
                        2017 봅슬레이 스켈레톤 국가대표 영양사<br/><br/>
                        2018 동면중 유튜브 채널 개설<br/><br/>
                        2019 겨울잠 창업<br/><br/>
                        2020 영양상담 사이트 개설, 회원 9만명 달성
                      </div>
                    </p>
                  </Grid>
                </Grid>
              </div>
              <div className="section" id="_3" style={{ flexGrow: 1, }}>
                <Grid container >
                  <Grid item xs={12} style={{padding:10}}>
                    <Grid container item xs={12} style={{position:'relative'}}>
                      <Grid className='line-after-white' item sm={4} xs={2} style={{float:'left',borderBottom:"1px solid rgba(255,255,255,0.4)",}}>

                      </Grid>
                      <Grid item sm={4}xs={8} style={{
                        fontWeight: 900,
                        fontSize: (mobile) ? "3em":"5em",
                        color: 'white',
                        lineHeight: 1,
                      }}>
                        YOUTUBE
                      </Grid>
                      <Grid className='line-before-white' item sm={4} xs={2} style={{float:'left',borderBottom:"1px solid  rgba(255,255,255,0.4)",}}>

                      </Grid>
                    </Grid>
                    <Grid item xs={12} style={{
                      marginTop:20,
                      fontWeight: 900,
                      fontSize: (mobile) ? "1em":"2em",
                      color: 'white',
                    }}>
                      유튜브 채널을 통해 전문적인 스포츠 영양 정보를 함께 나누고 있습니다.
                    </Grid>
                  </Grid>

                  <Grid item xs={12} style={{ height: '100px' }}>

                  </Grid>

                  <Grid item sm={4} xs={12}>

                    <a href="https://www.youtube.com/channel/UCsJz24ntgtEsdC1sfQ7bZTQ" target="_blank">
                      <img src={youtube_capture} style={{ width: mobile?"95%":"80%", }}/>
                    </a>
                  </Grid>
                  <Grid item sm={4} xs={6} style={{ marginTop: mobile?30:0}}>

                    <a href="https://www.youtube.com/watch?v=tgi5udrgTHQ" target="_blank">
                      <img src={food2} style={{ width: mobile?"90%":"80%" }}/>
                    </a>
                  </Grid>
                  <Grid item sm={4} xs={6} style={{ marginTop: mobile?30:0}}>

                    <a href="https://www.youtube.com/watch?v=kyusxk4jQhk" target="_blank">
                      <img src={metabolism} style={{ width: mobile?"90%":"80%" }}/>
                    </a>
                  </Grid>

                </Grid>
              </div>
              <div className="section" id="_4" style={{ flexGrow: 1, }}>
                <Grid container >
                  <Grid item xs={12} style={{padding:10}}>
                    <Grid container item xs={12} style={{position:'relative'}}>
                      <Grid  className='line-after-white' item sm={4} xs={2} style={{float:'left',borderBottom:"1px solid rgba(255,255,255,0.4)",}}>

                      </Grid>
                      <Grid item sm={4}xs={8} style={{
                        fontWeight: 900,
                        fontSize: (mobile) ? "3em":"5em",
                        color: 'white',
                        lineHeight: 1,
                      }}>
                        운동도우미
                      </Grid>
                      <Grid className='line-before-white' item sm={4} xs={2} style={{float:'left',borderBottom:"1px solid  rgba(255,255,255,0.4)",}}>

                      </Grid>
                    </Grid>
                    <Grid item xs={12} style={{
                      marginTop:20,
                      fontWeight: 900,
                      fontSize: (mobile) ? "1em":"2em",
                      color: 'white',
                    }}>
                      웹 및 모바일 서비스를 통해 사용자 친화적인 영양 운동 도우미를 제공합니다.
                    </Grid>
                  </Grid>

                  <Grid item xs={12} style={{ height: mobile? 0:'100px' }}>

                  </Grid>

                  <Grid item sm={6} xs={12}>
                    <a href="https://wintersleeping.com" target="_blank">
                      <img src={web1}  style={{ width: mobile?"90%":"80%" }}/>
                    </a>
                  </Grid>
                  <Grid item sm={6} xs={12}  style={{ marginTop: mobile?30:0}}>
                    <a href="https://play.google.com/store/apps/details?id=com.wintersleeping.mobile1" target="_blank">
                      <img src={mobile1}  style={{ width: mobile?"90%":"60%" }}/>
                    </a>
                    <br/>
                    <a href="https://apps.apple.com/us/app/%EB%8F%99%EB%A9%B4%EC%A4%91%EC%9D%98-%EC%9A%B4%EB%8F%99%EB%8F%84%EC%9A%B0%EB%AF%B8/id1542734373" target="_blank">
                      <img src={mobile2}  style={{ width: mobile?"90%":"60%" }}/>
                    </a>
                  </Grid>

                </Grid>
              </div>
            </ReactFullpage.Wrapper>
          );
        }}
      />

      <div style={{position:'absolute', bottom:0, right:0, fontSize:8, color:'white',}}>
        본 사이트는 (재)고양지식정보산업진흥원의 지원을 받아 제작 되었습니다.
      </div>
    </div>
  );
}

export default Home;